/**
 * Animated background particles for auth layout
 * Creates a magical AI-themed atmosphere
 */

import './AuthParticles.scss';

export function AuthParticles() {
  return (
    <div className="auth-particles">
      <div className="auth-particle auth-particle-1"></div>
      <div className="auth-particle auth-particle-2"></div>
      <div className="auth-particle auth-particle-3"></div>
      <div className="auth-particle auth-particle-4"></div>
      <div className="auth-particle auth-particle-5"></div>
      <div className="auth-particle auth-particle-6"></div>
    </div>
  );
}
